import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter as Router } from "react-router-dom"
import { RecoilRoot } from "recoil"

import { initializeEventTracker } from "lib/eventTracker"
import logger from "lib/logger"

import App from "./App"
import reportWebVitals from "./reportWebVitals"

import "normalize.css"

// ★ **モジュールのトップレベルで呼んでいます。** ここで例外が出ると
//   `ReactDOM.render` に到達せず、アプリが 1 画面も描画されません（白画面）。
//   マウント前なのでエラーバウンダリも効きません。
//   `initializeEventTracker` は **決して throw しない**契約です（#427）。
//   計測の失敗でアプリを止めないこと。
initializeEventTracker()

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
      <Router>
        <App />
      </Router>
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById("root"),
  () => {
    logger("react app mounted")
  },
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
